module.exports = __webpack_public_path__ + "img/banner_header.5ca316aa.png";